import { FLEECE_EXPENSES_FAILED, FLEECE_EXPENSES_REQUEST, FLEECE_EXPENSES_SUCCESS } from "app/redux/actions/Master/Expenses/FleeceExpenses/constant";


const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const fleeceExpensesReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case FLEECE_EXPENSES_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLEECE_EXPENSES_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLEECE_EXPENSES_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};